module.exports = "<p>דרוש/ה בודק/ת QA אשר יהיה/תהיה אחראי/ת על בקרת איכות המוצר של החברה</p> <p><strong>דרישות:</strong></p> <ul> <li><p>ניסיון בבדיקות מוצר (אתרים /אפליקציות) - יתרון</p> </li> <li><p>כתיבת מסמכי בדיקות STP, STR, STD</p> </li> <li><p>עבודה במתודולוגית Agile</p> </li> <li><p>הכרות עם בדיקות אוטומטיות</p> </li> <li><p>עבודה עם API</p> </li> <li><p>הכרות עם Git, JIRA</p> </li> <li><p>בעל /ת חשיבה הגיונית, יכולת הבנה של תהליכים מורכבים ויכולת למידה מהירה</p> </li> </ul> <p><strong>קורות חיים נא לשלוח ל- <a href=mailto:info@onmap.co.il>info@onmap.co.il</a></strong></p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/vacancies/en/qa.md
// module id = 828
// module chunks = 0